module.exports = __webpack_public_path__ + "static/img/cover-thumb.461565b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover-thumb.png
// module id = gTHA
// module chunks = 1